var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftquote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.92 13.36C13.2533 13.9467 14.2933 14.8267 15.04 16C15.7867 17.1733 16.16 18.56 16.16 20.16C16.16 22.4533 15.44 24.32 14 25.76C12.56 27.1467 10.72 27.84 8.48 27.84C6.24 27.84 4.37333 27.12 2.88 25.68C1.44 24.24 0.72 22.4 0.72 20.16C0.72 19.0933 0.853333 18.0267 1.12 16.96C1.38667 15.8933 1.97333 14.2933 2.88 12.16L7.52 0.639997H15.44L11.92 13.36ZM30.8 13.36C32.1333 13.9467 33.1733 14.8267 33.92 16C34.6667 17.1733 35.04 18.56 35.04 20.16C35.04 22.4533 34.32 24.32 32.88 25.76C31.44 27.1467 29.6 27.84 27.36 27.84C25.12 27.84 23.2533 27.12 21.76 25.68C20.32 24.24 19.6 22.4 19.6 20.16C19.6 19.0933 19.7333 18.0267 20 16.96C20.2667 15.8933 20.8533 14.2933 21.76 12.16L26.4 0.639997H34.32L30.8 13.36Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftquote);
export default __webpack_public_path__ + "static/media/left quote.d0135fe8.svg";
export { ForwardRef as ReactComponent };